import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  poweredByBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  poweredByTitle: {
    color: colors.neutral[900],
    fontSize: '1.4rem',
    lineHeight: '2rem',
    letterSpacing: '0.02em',
    marginBottom: '0.5rem',
  },
  imLogoWrapper: {
    width: '100%',
    '& img': {
      width: '100%',
      height: '100%',
      maxHeight: '2rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
